import { List, Create, Edit, Users } from "../Components/index.js";

export default [
    {
        path: "/admin/division",
        component: List,
        name: "division-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/division/:id/edit",
        component: Edit,
        name: "division-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/division/:division_id/users",
        component: Users,
        name: "division-users",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/division/create",
        component: Create,
        name: "division-create",
        meta: {
            requiresAuth: true,
        },
    },
];
